import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 16px 24px 20px;
    background-color: transparent;
    margin-top: auto;
  `}
`
